import { SportServicesService } from 'src/app/services/sport-service/sport-services.service';
import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserManagerService } from '../../services/user-manager/user-manager.service';
import Swal from 'sweetalert2';
import {SESSION_STORAGE, WebStorageService} from 'angular-webstorage-service';
import { TranslateService } from '@ngx-translate/core';
import { ResetPasswordComponent } from 'src/app/components/reset-password/reset-password.component';
import { MatDialog } from '@angular/material';
import { HelperFunctions } from 'src/app/services/helper-functions';
import { UiService } from 'src/app/services/ui/ui.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  data = {
    matricule: '',
    password: '',
  };
  valid = {
    password: true,
    matricule: true

  };
  loagingIn = false;
  login = {
    inProgress: false,
    err: false,
    reason: ''
  };
  path = '';
  createdSuccessfully = false;

  constructor(private router: Router,
              public userService: UserManagerService,
              public sportService: SportServicesService,
              private translate: TranslateService,
              private helperFunction: HelperFunctions,
              private uiService: UiService,
              public dialog: MatDialog,
              @Inject(SESSION_STORAGE) private storage: WebStorageService) { }

  ngOnInit() {
    // this.resetPassword();
    Swal.close();
    clearInterval(this.userService.idleInterval);
    this.getFromLocal('login');
  }
resetPassword() {
  const dialogRef = this.dialog.open(ResetPasswordComponent, {
    maxWidth: '80%',
    disableClose: true,
    panelClass: "scrollable",
    data: {created: this.createdSuccessfully,
    login: this.data.matricule}
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      console.log(result);
    }
  });
}
  getFromLocal(key): void {
    // console.log('recieved= key:' + key);
    let session = this.storage.get(key);
    // console.log(session);
    this.userService.isLoggedIn = session ? session.login : false;

    if(session){
      this.userService.logindata = session.data;
      this.sportService.parameters = session.params;
      this.path = (session.path && session.path.includes('#')) ? session.path.split('#')[1] : session.path;
      if (session.data.info.hasOwnProperty('lang')) {
        const lang = this.uiService.getSupportedLanguage(session.data.info.lang.name.toString().toLowerCase());
        this.translate.setDefaultLang(lang);
      }

      if(this.path){

        let menu = this.path.split('/')[2];
        // tslint:disable-next-line: triple-equals
        if (menu) {
          if (menu === 'client') {
            this.path = '/home/clients';
          } else {
            this.path = '/home/' + this.path.split('/')[2];
          }
        }else {
          menu = this.path.split('/')[1];
        }

        this.router.navigate([this.path]);
        this.openSideMenu(menu);
      }
    }


  // console.log('checking for which to expand',this.path.split('/')[2]);
  }
     openSideMenu(menu) {
      switch (menu) {
        case 'dashboard':

            this.userService.sideMenu.submenu = 0;
            break;
        case 'sport' : case 'category' : case 'games' : case 'tournament' : case 'event' : case 'categories':

            this.userService.sideMenu.submenu = 1;
            break;
        case 'market' : case'group':

            this.userService.sideMenu.submenu = 2;
            break;
        case 'clients':

            this.userService.sideMenu.submenu = 3;
            break;
        case 'channel':

            this.userService.sideMenu.submenu = 4;
            break;
        case 'publicity' : case 'text-slidders' :

            this.userService.sideMenu.submenu = 5;
            break;
        case 'tickets':
        case 'suspended_payment':

          this.userService.sideMenu.submenu = 6;
          break;
          case 'partners': case 'products': case 'product-type':

            this.userService.sideMenu.submenu = 7;
            break;
        case 'avis-expert': case 'promotions':

          this.userService.sideMenu.submenu = 8;
          break;
         case 'notification' : case 'dashboard-config' :
         case 'package-config' : case 'tax-configuration' :
         case 'tax-configuration' : case 'bonus-settings' :
         case 'bet-settings':

          this.userService.sideMenu.submenu = 9;
          break;
        case 'risk-config':

            this.userService.sideMenu.submenu = 10;
            break;
        case 'black-list' : case 'payments': case 'providers':

            this.userService.sideMenu.submenu = 11;
            break;
        case 'products' : case 'partners': case 'product-type':

          this.userService.sideMenu.submenu = 12;
          break;

      case 'PRS' :

          this.userService.sideMenu.submenu = 11;
          break;
      }

     }
  onSubmit(f) {
    if (this.userService.hasPreviouslyLoggedIn) {
      this.data.matricule = this.userService.logindata.info.login;
    }
    if (this.data.matricule === '' ) {
      this.valid.matricule = false;
    }
    if (this.data.password === '') {
      this.valid.password = false;
    }
    if (this.data.matricule === '' || this.data.password === '' || this.login.inProgress) {
      return false;
    }
    this.login.inProgress = true;
    this.userService.login(this.data.matricule, this.data.password).then(data => {      
      if (data.error) {
        if(data.status) {
          switch (data.status) {
            case '500':
               this.helperFunction.presentAlert('warning', this.translate.instant('confirm') + '?',
                '', this.translate.instant('update_password')).then(result => {
                  if (result.value) {
                  this.resetPassword()
                  }
                });
              break;
            case '106':
              this.helperFunction.presentAlert('warning', this.translate.instant('confirm') + '?',
                '', this.translate.instant(data.msg)).then(result => {
                  if (result.value) {
                  this.resetPassword();
                  }
                });
              break;
          
            default:
              break;
          }

        } else {
          this.login.err = true;
          this.login.reason = data.msg;
        }
       
      } else {
        if (this.userService.hasPreviouslyLoggedIn) {
          history.back();
        } else {
          // console.log(data)
          // this.router.navigate([`/home/${this.userService.logindata.info.prefPage}`]);
          // console.log(this.userService.logindata.info.profile.trim().toLowerCase());
          // tslint:disable-next-line: triple-equals
          if ( this.userService.logindata.info.profile && this.userService.logindata.info.profile.trim().toLowerCase() == 'admin sgcj') {
            this.path = '/home/clients';
          } else if (this.userService.logindata.info.profile && this.userService.logindata.info.profile.trim().toLowerCase() == 'risk admin') {
            this.path = '/home/threshold-config/monitored-values';
          } else {
            this.path = '/home/dashboard';
          }


          let splittedPath = this.path.split('/');

          let menu = 'dashboard';

          if(this.path.includes('clients')){
            menu = 'client';
          }else if(splittedPath.length > 2){
            menu = splittedPath[2];
          }


          this.router.navigate([this.path]);
          this.openSideMenu(menu);

        }
      }
    }).catch(err => {
      this.login.err = true;
      this.login.reason = err.msg;
    }).finally( () => {
      this.login.inProgress = false;
      // this.router.navigate(['/home/dashboard']);
    });
  }
  onClose(message) {
    this.login.err = false;
    this.login.reason = '';

  }
}
